<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h4 class="title">Task Category Management</h4>
              <button
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#categoryModal"
                class="btn btn-primary btn-sm"
                id="openCategoryModal"
                @click="openCategoryModal(true)"
              >
                Add New Category
              </button>

              <button
                hidden
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#categoryModal"
                class="btn btn-primary"
                id="openModal"
                @click="openModal()"
              >
                Add New Category
              </button>
              <button
                hidden
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#categoryDeleteConfirmModal"
                data-bs-whatever="@mdo"
                class="btn btn-primary"
                id="openDeleteCategoryModal"
              >
                Delete category
              </button>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="col-md-12">
              <div
                v-if="successAlertOnSubmit"
                class="alert alert-success text-left"
                role="alert"
              >
                {{ successAlertOnSubmit }}
                <span @click="hideCategoryAlert" class="close-icon"
                  >&times;</span
                >
              </div>
              <div
                v-if="errorAlertOnSubmit"
                class="alert alert-danger text-left"
                role="alert"
              >
                {{ errorAlertOnSubmit }}
                <span @click="hideCategoryAlert" class="close-icon"
                  >&times;</span
                >
              </div>
              <div class="table-responsive">
                <div v-if="loadingCategories" class="text-center">
                  <p>Loading..</p>
                </div>
                <!-- <md-table
                  v-if="!loadingCategories"
                  v-model="categories"
                  :table-header-color="tableHeaderColor"
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
        
                    <md-table-cell md-label="Name" style="width:30%;">{{
                      item.CategoryName
                    }}</md-table-cell>
                    <md-table-cell md-label="Parent Category" style="width:30%;">{{
                      item.ParentCategoryName
                    }}</md-table-cell>
                    <md-table-cell md-label="Order By" style="width:25%;">{{
                      item.OrderBy
                    }}</md-table-cell>
                    <md-table-cell md-label="Actions" style="float: right;">
                      <button
                        @click="editCategory(item.CategoryID)"
                        type="button"
                        class="btn btn-primary btn-sm ml-2"
                        title="Edit"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                        @click="openDeleteModal(item.CategoryID)"
                        type="button"
                        class="btn btn-danger btn-sm"
                        title="Delete"
                      >
                        <md-icon style="color: white">delete</md-icon>
                      </button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
               -->
               <table style="width: 100%;" v-if="!loadingCategories"
:table-header-color="tableHeaderColor">
  <tr  style="color: rgba(0, 0, 0, 0.54);border-bottom: 1px solid #ddd;">
    <td style="width:50%" class="table-cell">Category Name</td>
    <!-- <td style="width:35%" class="table-cell">Parent Category</td>
    <td style="width:22%" class="table-cell">Order By</td> -->
    <td style="width:50%;text-align:right" class="table-cell">Actions</td>
  </tr>
  <tr slot="md-table-row"
    v-for="item in categories" :key="item.id"
    class="" style="border-bottom: 1px solid #ddd;">
<td class="md-table-cell">
  {{item.CategoryName}}
</td>
<!-- <td class="md-table-cell">
{{item.ParentCategoryName}}
</td>
<td class="md-table-cell">{{ item.OrderBy }}</td> -->
<td class="md-table-cell" style="text-align:right">

  <button
  @click="editCategory(item.CategoryID)"
  type="button"
  class="btn btn-primary btn-sm ml-2"
  title="Edit"
>
  <i class="fas fa-pencil-alt"></i>
</button>
<button
  @click="openDeleteModal(item.CategoryID)"
  type="button"
  class="btn btn-danger btn-sm"
  title="Delete"
>
  <md-icon style="color: white">delete</md-icon>
</button>
</td>
  </tr>
</table>
              </div>
            </div>
            <div
              class="modal fade"
              id="categoryModal"
              tabindex="-1"
              aria-labelledby="categoryModalLabel"
              aria-hidden="true"
              @hidden="handleCategoryModalHidden"
            >
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h1 class="modal-title fs-5" id="categoryModalLabel">
                      {{
                        editCategoryMode
                          ? "Edit Task Category"
                          : "Add New Task Category"
                      }}
                    </h1>
                    <button
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      tabindex="-1"
                    ></button>
                  </div>
                  <form @submit.prevent="submitCategoryForm">
                    <input
                      v-model="newCategory.CategoryID"
                      type="hidden"
                      class="form-control"
                    />
                    <div class="modal-body">
                      <div
                        v-if="categoryFormHeader"
                        class="alert alert-danger text-left"
                        role="alert"
                      >
                        {{ categoryFormHeader }}
                        <span @click="hideCategoryAlert" class="close-icon"
                          >&times;</span
                        >
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label for="name" class="col-form-label"
                              >Category Name</label
                            >
                            <input
                              v-model="newCategory.Name"
                              type="text"
                              class="form-control"
                              maxlength="30"
                              id="name"
                              tabindex="1"
                              @input="isValidCategoryForm"
                            />
                            <span class="text-red-500 text-sm">{{
                              categoryValidate.Name
                            }}</span>
                          </div>
                        </div>
                        <!-- <div class="col-md-6">
                          <div class="mb-3">
                            <label for="parentCategory" class="col-form-label"
                              >Parent Category:</label
                            >
                            <select
                              v-model="newCategory.ParentCategoryID"
                              class="form-control"
                              id="parentCategory"
                              tabindex="2"
                              placeholder="Select Parent Category"
                            >
                              <option :value="null">
                                Select Parent Category
                              </option>
                              <option
                                v-for="parentCategory in parentCategoriesDropdown"
                                :key="parentCategory.CategoryID"
                                :value="parentCategory.CategoryID"
                              >
                                {{ parentCategory.Name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label for="orderBy" class="col-form-label"
                              >Order By:</label
                            >
                            <input
                              v-model="newCategory.OrderBy"
                              type="number"
                              class="form-control"
                              id="orderBy"
                              tabindex="3"
                            />
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary ml-2"
                        data-bs-dismiss="modal"
                        tabindex="5"
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        default
                        tabindex="4"
                        :disabled="btnCategoryEnable"
                      >
                        {{ editCategoryMode ? "Update" : "Submit" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Modal for confirm delete category -->
            <div
              class="modal fade"
              id="categoryDeleteConfirmModal"
              tabindex="-1"
              aria-labelledby="DeleteConfirmModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-md">
                <div class="modal-content">
                  <form @submit.prevent="submitDeleteCategoryForm">
                    <input
                      v-model="newCategory.CategoryID"
                      type="hidden"
                      class="form-control"
                    />
                    <div class="modal-body">
                      <div class="row">
                        <h4>Are you sure you want to delete {{newCategory.CategoryName}} Category?</h4>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary ml-2"
                        data-bs-dismiss="modal"
                        id="closeDeleteConfirmCategoryModal"
                        tabindex="8"
                      >
                        No
                      </button>
                      <button type="submit" class="btn btn-danger" tabindex="7" :disabled="btnCategoryEnable">
                        Yes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import api, { setAuthToken } from "../apiConfig";
import { authMixin } from "./adminStore";
import Cookies from "js-cookie";

export default {
  mixins: [authMixin],
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  created() {
    this.checkAuthorization();
  },
  name: "CategoryManagement",
  data() {
    return {
      name:"Task  Category",
      categories: [],
      parentCategoriesDropdown: [],
      newCategory: {
        CategoryID: 0,
        Name: "",
        ParentCategoryID: null,
        OrderBy: 0,
      },
      categoryValidate: {
        Name: "",
      },
      categoryFormHeader: "",
      successAlertOnSubmit: "",
      errorAlertOnSubmit: "",
      editCategoryMode: false,
      loadingCategories: "",
      btnCategoryEnable: false,
    };
  },
  computed: {},
  mounted() {
    this.getCategories();
    this.fetchParentCategoriesDropdown();
    const token = Cookies.get("jwt");
    setAuthToken(token);
  },
  methods: {
    handleCategoryModalHidden() {
      this.editCategoryMode = false;
    },
    openModal() {
      document.getElementById("openModal").click();
    },
    openCategoryModal(refresh = false) {
      if (refresh) {
        this.editCategoryMode = false;
        this.newCategory = {
          CategoryID: 0,
          Name: "",
          ParentCategoryID: 0,
          OrderBy: 0,
        };
        this.resetCategoryValidation();
      }
      document.getElementById("openCategoryModal").click();
    },
    closeDeleteConfirmCategoryModal() {
      document.getElementById("closeDeleteConfirmCategoryModal").click();
    },
    openDeleteModal(categoryId) {
      this.newCategory.CategoryID = categoryId;
      var filterCat=this.categories.filter(item => {
            return (
              item.CategoryID==parseInt(categoryId)
            );
            
          });
          this.newCategory.CategoryName=filterCat[0].CategoryName;
          console.log(filterCat[0].CategoryName);
      document.getElementById("openDeleteCategoryModal").click();
    },
    async getCategories() {
      this.categories = [];
      this.loadingCategories = "Loading...";
      try {
        const token = Cookies.get("jwt");
        setAuthToken(token);
        const response = await api.get("/api/categories/get-categories");
        if (response.data) {
          this.categories = response.data;
          console.log(response.data);
        } else {
          // Handle case where no categories are found
        }
      } catch (error) {
        // Handle API error
      } finally {
        if (this.categories.length > 0) {
          this.loadingCategories = "";
        } else {
          this.loadingCategories = "No record found.";
        }
      }
    },
    async fetchParentCategoriesDropdown() {
      try {
        const token = Cookies.get("jwt");
        setAuthToken(token);
        const response = await api.get(
          "/api/categories/get-categories-dropdown"
        );
        if (response.data) {
          this.parentCategoriesDropdown = response.data;
        } else {
          // Handle case where no categories are found
        }
      } catch (error) {
        // Handle API error
      }
    },
    async getCategoryById(categoryId) {
      try {
        const token = Cookies.get("jwt");
        setAuthToken(token);
        const response = await api.get(
          `/api/categories/get-category-by-id/${categoryId}`
        );
        if (response.data) {
          this.newCategory = response.data[0];
          this.openModal();
          this.resetCategoryValidation();
        } else {
          alert(`Error: ${response.statusText}`);
        }
        // Continue with any other logic (e.g., navigate to a different page)
      } catch (error) {
        //console.log(error);
        if (error.response.status == 401) {
          const jsonResponseString = JSON.stringify(
            error.response.data.message
          );
          alert(jsonResponseString);
          this.$router.push("/");
        }
        alert("Interval server error.");
      }
    },
    async createCategory() {
      this.categoryFormHeader = "";
      try {
        this.btnCategoryEnable = true;
        const token = Cookies.get("jwt");
        setAuthToken(token);
        const response = await api.post("/api/categories/create-category", {
          Name: this.newCategory.Name,
          ParentCategoryID: 0,
          OrderBy: 0,
        });

        if (response.data.success) {
          this.getCategories();
          this.openCategoryModal(); // hide modal after successful submit.
          this.successAlertOnSubmit = "Category added successfully.";
          this.categoryFormHeader="";
          this.errorAlertOnSubmit="";
        } else {
          this.categoryFormHeader = response.data.msg;
          this.errorAlertOnSubmit="";
          this.successAlertOnSubmit="";
        }
      } catch (error) {
        // Handle API error
      } finally {
        this.btnCategoryEnable = false;
      }
    },
    editCategory(categoryId) {
      this.editCategoryMode = true;
      this.getCategoryById(categoryId);
    },
    async updateCategory() {
      this.categoryFormHeader = "";
      try {
        this.btnCategoryEnable = true;
        const token = Cookies.get("jwt");
        setAuthToken(token);
        const response = await api.put(
          `/api/categories/update-category/${this.newCategory.CategoryID}`,
          {
            Name: this.newCategory.Name,
            ParentCategoryID: 0,
            OrderBy: 0,
          }
        );

        if (response.data.success) {
          this.getCategories();
          this.openCategoryModal(); // hide modal after successful submit.
          this.errorAlertOnSubmit="";
          this.successAlertOnSubmit = "Category updated successfully.";
          
          
        } else {
          this.categoryFormHeader = response.data.msg;
          this.errorAlertOnSubmit="";
        }
      } catch (error) {
        // Handle API error
      } finally {
        this.btnCategoryEnable = false;
      }
    },
    async deleteCategory(categoryId) {
      try {
        const token = Cookies.get("jwt");
        setAuthToken(token);
        this.btnCategoryEnable = true;
        const response = await api.delete(
          `/api/categories/delete-category/${categoryId}`
        );

        if (response.status == 200) {
          //console.log(response);
          if (response.data.success) {
            this.getCategories();
            //this.closeDeleteConfirmCategoryModal();
            this.successAlertOnSubmit = "Category deleted successfully.";
            this.errorAlertOnSubmit="";
          } else {
            this.errorAlertOnSubmit = response.data.msg;
            this.successAlertOnSubmit="";
          }
        } else {
          alert(response.statusText);
        }
      } catch (error) {
        // Handle API error
      }
      finally{
        this.closeDeleteConfirmCategoryModal();
        this.btnCategoryEnable = false;
      }
    },
    submitDeleteCategoryForm() {
      this.deleteCategory(this.newCategory.CategoryID);
    },
    isValidCategoryForm() {
      let isValid = true;

      // Name
      if (!this.newCategory.Name.trim()) {
        this.categoryValidate.Name = "Category name is required";
        isValid = false;
      }
      else{
        this.categoryValidate.Name = "";
        isValid = true;
      }
      if (this.newCategory.Name.length>30) {
        this.categoryValidate.Name = "max length is 30";
        isValid = false;
      }


      return isValid;
    },

    async submitCategoryForm() {
      this.resetCategoryValidation();

      if (this.isValidCategoryForm()) {
        this.newCategory.ParentCategoryID =
          this.newCategory.ParentCategoryID === "null"
            ? null
            : this.newCategory.ParentCategoryID;
        this.newCategory.CategoryID === 0
          ? this.createCategory()
          : this.updateCategory();
      }
    },

    resetCategoryValidation() {
      this.categoryValidate = {
        Name: "",
      };
    },

    hideCategoryAlert() {
      this.categoryFormHeader = "";
      this.successAlertOnSubmit = "";
      this.errorAlertOnSubmit = "";
    },
  },
};
</script>

<style scoped>
/* Add Tailwind CSS classes here if needed */
/* Add additional styling as needed for PriorityManagement */
.close-icon {
  cursor: pointer;
  float: right;
  font-size: 30px;
  margin-top: -10px;
}
.mb-3 {
  text-align: left;
}
.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1em;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
.table-cell{
  font-size: 1.0625rem;
    padding-bottom: 10px;
    font-weight: 500;
}

.table th {
  background-color: #f2f2f2;
}

/* Additional styling for left and right padding */
.table th,
.table td {
  padding-left: 12px;
  padding-right: 12px;
}

.actionBtns {
  text-align: right !important;
  width: 200px !important;
}
.modal-content .modal-header{
  padding-top:10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.modal-title{
  margin-top:10px;
}
.modal-content .modal-body{
  padding-top:10px;
}
</style>
